export const FEATURES = {
  OPS_MASKED_PHONE_NUMBERS: 'ops_masked_phone_numbers',
  RELEASE_BUYER_APPLICATION_AUTH_REMOVAL:
    'release_buyer_application_auth_removal',
  REL_BNPL_TOGGLE: 'rel_bnpl_toggle',
  REL_NAV_REFRESH: 'rel_nav_refresh',
  REL_DETAILS_TAB: 'rel_details_tab',
  REL_CONTRACTS_V2: 'rel_contracts_v2',
  REL_PUPPY_PREFERENCE: 'rel_puppy_preference',
  REL_ASSIGN_PUPPY_MODAL: 'rel_assign_puppy_modal',
  REL_BREEDER_REVIEW_PHONE_WORK: 'rel_breeder_review_phone_work',
  REL_PUPPY_APP_ASSIGNMENT_UPDATE: 'rel_puppy_app_assignment_update',
  REL_MOVE_LITTER_TO_PAST_MODAL: 'rel_move_litter_to_past_modal',
  REL_PAYMENT_POLICY_LETTER_MODAL: 'rel_payment_policy_letter_modal',
  REL_BREEDER_PAYMENT_ENFORCEMENT: 'rel_breeder_payment_enforcement',
  REL_LITTER_GROUP_MESSAGING: 'rel_litter_group_messaging',
  REL_WEB_UI_LITTER_GROUP_MESSAGING: 'rel_web_ui_litter_group_messaging',
  REL_GETTING_YOUR_PUPPY: 'rel_getting_your_puppy'
};
